/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import useParamsRouter from '../../../hooks/useParamsRouter';
import { GetCredentialAndGrouping } from '../gql/sharedQueries';
import { GDPR_SETTING } from '../../../utils/constants';

export function FormRow({ form }) {
    const history = useHistory();
    let unformattedGDPRSetting = form?.gdprSetting;
    if (form.formMetadata.formAttributesConfig.impliedConsent && unformattedGDPRSetting !== GDPR_SETTING.NEVER) {
        unformattedGDPRSetting = unformattedGDPRSetting.concat(' Implied');
    }
    const formattedGDPRSetting = unformattedGDPRSetting.charAt(0).toUpperCase() + unformattedGDPRSetting.slice(1);
    let statusColor;

    if (form.publishedStatus === 'Current') {
        statusColor = 'green';
    } else if (form.publishedStatus === 'Modified') {
        statusColor = 'orange';
    } else {
        statusColor = 'gray';
    }

    return (
        <tr id={`form-${form.id}`}
            onClick={() => history.push(`./forms/${form.id}`)}
        >
            <td>{form.name}</td>
            <td>{form.program.degreeOffering}</td>
            <td style={{ color: statusColor }}>{form.publishedStatus}</td>
            <td>{formattedGDPRSetting}</td>
            <td>{form.id}</td>
            <td id={`experimental-status-${form.id}`}>{form.isExperimentalForm ? 'Yes' : ''}</td>
        </tr>
    );
}

export default function FormTable() {
    const { credentialTypeIdInt, groupingIdInt } = useParamsRouter();
    const { data: { grouping } = {}, loading } = useQuery(GetCredentialAndGrouping, {
        variables: { groupingIdInt, credentialTypeIdInt },
    });
    if (loading) {
        return <div>Loading...</div>;
    }
    const rows = grouping.forms.map((form) => <FormRow
        form={form}
    />);
    return (
        <div>
            <div className="row mt-4">
                <div className="col-12">
                    <table className="table table-hover bg-white border">
                        <thead>
                            <tr className="text-uppercase" style={{ fontSize: '0.75rem' }}>
                                <th scope="col">Form Name</th>
                                <th scope="col">Degree Offering(s)</th>
                                <th scope="col">Published</th>
                                <th scope="col">GDPR Consent</th>
                                <th scope="col">ID</th>
                                <th scope="col" id="experimental-status-col">Experimental</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
